import React from "react";

/**
 * A component that renders a service card in the home page
 *
 * @param {Object} props
 * @param {string} props.title - The title of the service card
 * @param {string} props.description - The description of the service card
 * @param {string} props.img - The HTML src attribute of the image of the service
 * @param {string} props.alt - The HTML alt attribute of the image of the service
 * @returns {JSX.Element}
 */

const ServiceCard = ({ title, description, img, alt }) => {
  return (
    <div className="px-6 py-10 bg-background_grey rounded-lg transition-all duration-300 group hover:bg-hover_steel_blue">
      <div className="rounded-full mb-9 w-fit ms-auto p-4 flex justify-center items-center transition-all duration-300 bg-background_steel_blue text-text_white group-hover:bg-background_white">
        <img src={img} alt={alt} className="w-12 h-12" />
      </div>
      <p className="font-bold mb-3 text-[#E9B838c6] group-hover:text-text_white text-3xl">
        {title}
      </p>
      <p className="font-normal text-sm text-black group-hover:text-text_white">
        {description}
      </p>
    </div>
  );
};

export default ServiceCard;
